/**
 * Returns the user's preferred table page size from localStorage,
 * falling back to the provided default if none is saved.
 */
export function getTablePageSize(fallback = 50): number {
  const saved = localStorage.getItem('table-rows-preference')
  if (saved) {
    const n = Number(saved)
    if (!isNaN(n) && n > 0) return n === 25 ? 50 : n
  }
  return fallback
}
